import { CreateUIMessage, UIMessage } from '@ai-sdk/react';

import { Metadata, UIChatMessage } from '../chat.types';

/**
 * Enum for message variants that can be passed in annotations
 */
export enum MessageVariant {
  DEFAULT = 'default',
  FILE_ATTACHMENT = 'fileAttachment',
  QUICK_ACTION = 'quickAction',
  SUGGESTION = 'suggestion',
}

export type SubmitArgs = {
  text: string;
};

/**
 * Base interface for message handlers
 */
export interface MessageHandler<M extends Metadata = never> {
  /**
   * Submit handler that takes UI inputs and returns an AI SDK message object
   * @param args - The UI inputs (submitArgs)
   * @param context - Required if M is defined, not allowed if M is never
   * @returns AI SDK message object for sending to the agent
   */
  submit: [M] extends [never]
    ? (args: SubmitArgs) => CreateUIMessage<UIChatMessage>
    : (args: SubmitArgs, context: M) => CreateUIMessage<UIChatMessage>;
}

/**
 * @deprecated
 * Used for file handling only, to be replaced with source-document parts
 *
 * Message handler that combines both rendering and submission logic
 */
export type LegacyMessageHandler<M extends Metadata> = MessageHandler<M> &
  (M['type'] extends MessageVariant.FILE_ATTACHMENT
    ? {
        parseParts: (
          parts: UIMessage['parts'],
          ...args: any[]
        ) => { files: Extract<M, { type: MessageVariant.FILE_ATTACHMENT }>['files']; content: string };
      }
    : { parseParts?: undefined });
